<template lang="pug">
yz-dialog(v-model="showDialog" persistent max-width="600px")
  yz-card
    yz-dialog-normal-header(title="Enable UOM Conversion" @close="showDialog = false")
    .px-6.py-6
      .yz-medium-body-md.text-neutral-700 Enabling UOM conversion requires switching to the new versions of:
      .mt-4
        .d-flex.align-center.mt-2
          v-icon.mr-2(size="20" color="success500") mdi-check-circle
          .yz-regular-body-sm.text-neutral-700 Registration
        .d-flex.align-center.mt-2
          v-icon.mr-2(size="20" color="success500") mdi-check-circle
          .yz-regular-body-sm.text-neutral-700 Consultation
        .d-flex.align-center.mt-2
          v-icon.mr-2(size="20" color="success500") mdi-check-circle
          .yz-regular-body-sm.text-neutral-700 Checkout / Dispensary
      .yz-regular-body-sm.text-neutral-500.mt-4 Once enabled, you will no longer be able to switch back to the old versions. This change applies to all users in this clinic.
    yz-dialog-normal-actions(save-label="I understand, proceed" :loading="isLoading" @cancel="showDialog = false" @save="onConsent")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async onConsent() {
      this.isLoading = true
      try {
        await this.$store.dispatch('clinic/enableCmsOsV2', this.$axios)
        this.$emit('consented')
        this.showDialog = false
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
